theme.headerSticky = (function() {
  /**
   * Initialisiert das "Sticky Header"-Verhalten auf eine performante Weise.
   */
  function ScrollSticky() {
    // 1. Elemente einmal am Anfang auswählen, um ständige Suchen im DOM zu vermeiden.
    const headerWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');
    
    // Bricht die Funktion ab, wenn die notwendigen Elemente nicht auf der Seite gefunden werden.
    if (!headerWrapper || !headerStickyTarget) {
      console.warn('Sticky Header Elemente nicht gefunden. Funktion wird nicht ausgeführt.');
      return;
    }
    
    // 2. Feste Werte außerhalb des Scroll-Events berechnen.
    // Die Höhe ist ein statischer Wert, der nur einmal gelesen werden muss.
    const activationOffset = headerWrapper.clientHeight;
    
    // 3. Statusvariablen, um unnötige Aktionen zu verhindern.
    // 'isTicking' stellt sicher, dass 'requestAnimationFrame' nicht bei jedem Scroll-Pixel neu aufgerufen wird.
    let isTicking = false;

    /**
     * Diese Funktion wird im nächsten verfügbaren Frame ausgeführt.
     * Sie prüft die Scroll-Position und aktualisiert die 'sticky'-Klasse NUR, wenn es nötig ist.
     */
    function updateHeaderState() {
      const scrollPosition = window.scrollY;

      // Bedingung prüfen: Ist die Scroll-Position größer als die Header-Höhe?
      if (scrollPosition > activationOffset) {
        // Füge die Klasse nur hinzu, wenn sie noch nicht vorhanden ist.
        if (!headerStickyTarget.classList.contains('sticky')) {
          headerStickyTarget.classList.add('sticky');
        }
      } else {
        // Entferne die Klasse nur, wenn sie vorhanden ist.
        if (headerStickyTarget.classList.contains('sticky')) {
          headerStickyTarget.classList.remove('sticky');
        }
      }
      
      // Setzt den Status zurück, damit beim nächsten Scroll-Ereignis eine neue Anfrage gestellt werden kann.
      isTicking = false;
    }

    /**
     * Dieser Event-Listener wird bei jedem Scrollen aufgerufen.
     * Seine einzige Aufgabe ist es, eine Aktualisierung für den nächsten Frame anzufordern.
     */
    function onScroll() {
      // Fordere nur dann einen neuen Frame an, wenn nicht bereits eine Anfrage läuft.
      if (!isTicking) {
        window.requestAnimationFrame(updateHeaderState);
        isTicking = true; // Markieren, dass eine Anfrage gestellt wurde.
      }
    }
    
    // Hänge den optimierten Event-Listener an das Scroll-Ereignis des Fensters.
    window.addEventListener('scroll', onScroll);
  }
  
  // Gibt die Hauptfunktion zurück, damit sie von custom.js registriert werden kann.
  return ScrollSticky;
})();